import React, { useRef, useState, useEffect, useMemo } from "react"

// redux
import { useNavigate } from "react-router-dom"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { motion, useMotionValueEvent, useScroll } from "framer-motion"
import { Modal } from "antd"
import axios from "axios"
import { APP_LOCALE, getLanguage, useLanguage } from "@languages/index"
import classNames from "classnames"
import { LOCALES } from "constants/locales"
import DOMAIN from "constants/domain"

const InviteIntroCommon = (props) => {
  const languageCode = getLanguage()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }

  const navigate = useNavigate()
  const [showFloatingButtons, setShowFloatingButtons] = useState(false)
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false)
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false)
  const [isManagerModalVisible, setIsManagerModalVisible] = useState(false)

  const scrollContainerRef = useRef(null)
  const { scrollY } = useScroll({
    container: scrollContainerRef,
  })

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextState = latest > 500 ? true : false
    if (showFloatingButtons != nextState) {
      setShowFloatingButtons(nextState)
    }
  })

  const openPDF = () => {
    let url = "https://" + DOMAIN.BASE.URL + "/intro/invite.pdf"
    window.open(url, "_blank")
  }

  const footerAnimVariants = {
    hidden: { opacity: 0, y: 300 },
    show: { opacity: 1, y: 0 },
  }

  const storeContact = () => {
    const members = props.brand.members.map((member) => {
      return {
        name: member.name,
        role: member.role,
        mobile: member.mobile,
      }
    })

    let api, message
    switch (APP_LOCALE) {
      case LOCALES.JA:
        api = "https://brand.kyolook.com/business/contact"
        message = `${languageTexts.intro_text_1} (JP)`
        break
      default:
        api = "https://brand.nmodelin.com/business/contact"
        message = `${languageTexts.intro_text_1} (KR)`
        break
    }

    axios
      .post(api, {
        name: props.brand.name,
        contact: JSON.stringify(members, undefined, 2),
        message: message,
      })
      .then((response) => {})
      .catch((error) => {
        console.log(error)
        alert(error.message)
      })
  }

  const showLoadingModal = () => {
    setIsProgressModalVisible(true)
  }

  const HeaderChildren = (
    <div className="flex flex-col max-w-[1600px] w-full mx-auto">
      <div className="flex flex-col justify-center items-center mb-[20px] md:mb-[30px]">
        <span
          className={classNames({
            "text-white leading-tight tracking-[-0.075em] font-bold text-center": true,
            "text-[28px] md:text-[42px] lg:text-[56px]": languageCode === LOCALES.KO,
            "text-[19px] md:text-[36px] lg:text-[56px]": languageCode === LOCALES.JA,
          })}
        >
          {languageTexts.intro_text_2}
          <br />
          {languageTexts.intro_text_3}
        </span>
      </div>

      <div
        className={classNames({
          "mb-[25px] md:mb-[36px] text-white text-center": true,
          "text-[16px] md:text-[17px] lg:text-[18px]": languageCode === LOCALES.KO,
          "text-[13px] md:text-[15px] lg:text-[18px]": languageCode === LOCALES.JA,
        })}
      >
        <span>{languageTexts.intro_text_4}</span>
      </div>

      <div className="flex flex-row gap-[5px] mx-auto justify-center">
        <div
          className="w-[149px] h-14 rounded-[56px] border border-white flex justify-center items-center cursor-pointer"
          onClick={() => {
            openPDF()
          }}
        >
          <span className="text-base text-center text-white font-bold">{languageTexts.intro_text_5}</span>
        </div>
        <div
          className={"w-[260px] h-14 bg-orange-500 rounded-[56px] flex justify-center items-center cursor-pointer"}
          onClick={() => {
            showLoadingModal()
          }}
        >
          <span
            className={classNames({
              "text-center text-white font-bold": true,
              "text-[16px]": languageCode === LOCALES.KO,
              "text-[12px]": languageCode === LOCALES.JA,
            })}
          >
            {languageTexts.intro_text_6}
          </span>
        </div>
      </div>
    </div>
  )

  return (
    <div
      ref={scrollContainerRef}
      style={{
        maxHeight: "100dvh",
        overflow: "scroll",
      }}
    >
      <div
        className="section-1 w-full h-[500px] flex md:hidden flex-col items-center justify-center py-[80px] bg-cover bg-center bg-black"
        style={{
          backgroundImage: `url('/assets/images/invite/invite-intro-01-m.png?v=240725')`,
          boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.3)",
        }}
      >
        {HeaderChildren}
      </div>
      <div
        className="section-1 w-full h-[680px] hidden md:flex flex-col items-center justify-center py-[80px] bg-cover bg-center bg-black"
        style={{
          backgroundImage: `url('/assets/images/invite/invite-intro-01.png?v=240725')`,
          boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.3)",
        }}
      >
        {HeaderChildren}
      </div>

      <div className="section-2 bg-white items-center justify-center py-[150px]">
        <div className="flex flex-col justify-center items-center max-w-[1024px] w-full mx-auto gap-[150px]">
          <div className="checkpoint-1 w-full px-[20px] md:px-0 flex flex-col">
            <span
              className={classNames({
                "mb-[15px] md:mb-[25px] text-[#000] font-bold leading-tight tracking-[-0.075em]": true,
                "text-[28px] md:text-[38px] lg:text-[48px]": languageCode === LOCALES.KO,
                "text-[17px] md:text-[32px] lg:text-[48px]": languageCode === LOCALES.JA,
              })}
            >
              {languageTexts._intro_text_7()}
            </span>
            <span
              className={classNames({
                "mb-[30px] md:mb-[50px] text-[#666]": true,
                "text-[16px] md:text-[17px] lg:text-[18px]": languageCode === LOCALES.KO,
                "text-[14px] md:text-[16px] lg:text-[18px]": languageCode === LOCALES.JA,
              })}
            >
              {languageTexts.intro_text_8}
            </span>
          </div>

          <div className="checkpoint-2 w-full px-[20px] md:px-0 flex flex-col lg:flex-row lg:gap-[40px]">
            <div className="flex flex-col lg:min-w-[520px]">
              <span
                className={classNames({
                  "mb-[15px] md:mb-[25px] text-[#000] font-bold leading-tight tracking-[-0.075em]": true,
                  "text-[28px] md:text-[38px] lg:text-[48px]": languageCode === LOCALES.KO,
                  "text-[24px] md:text-[32px] lg:text-[39px]": languageCode === LOCALES.JA,
                })}
              >
                {languageTexts._intro_text_9()}
              </span>
              <span
                className={classNames({
                  "mb-[30px] md:mb-[50px] text-[#666]": true,
                  "text-[16px] md:text-[17px] lg:text-[18px]": languageCode === LOCALES.KO,
                  "text-[10px] md:text-[12px] lg:text-[15px]": languageCode === LOCALES.JA,
                })}
              >
                {languageTexts._intro_text_10()}
              </span>
            </div>

            <div className="flex flex-col justify-center items-center w-full mx-auto mb-[100px] md:mb-[150px]">
              <img
                className="w-full h-full md:hidden"
                src={`/assets/images/invite/invite-intro-02-m_${languageCode}.png`}
              />
              <img
                className="w-full h-full hidden md:block"
                src={`/assets/images/invite/invite-intro-02_${languageCode}.png`}
              />
            </div>
          </div>

          <div className="checkpoint-3 w-full px-[20px] md:px-0 flex flex-col lg:flex-row lg:gap-[40px]">
            <div className="flex flex-col lg:min-w-[520px]">
              <span
                className={classNames({
                  "mb-[15px] md:mb-[25px] text-[#000] font-bold leading-tight tracking-[-0.075em]": true,
                  "text-[28px] md:text-[38px] lg:text-[48px]": languageCode === LOCALES.KO,
                  "text-[24px] md:text-[32px] lg:text-[40px]": languageCode === LOCALES.JA,
                })}
              >
                {languageTexts._intro_text_11()}
              </span>
              <span
                className={classNames({
                  "mb-[30px] md:mb-[50px] text-[#666]": true,
                  "text-[16px] md:text-[17px] lg:text-[18px]": languageCode === LOCALES.KO,
                  "text-[14px] md:text-[16px] lg:text-[18px]": languageCode === LOCALES.JA,
                })}
              >
                {languageTexts.intro_text_12}
              </span>
            </div>

            <div className="flex flex-col justify-center items-center w-full mx-auto mb-[100px] md:mb-[150px]">
              <img
                className="w-full h-full md:hidden"
                src={`/assets/images/invite/invite-intro-03-m_${languageCode}.png`}
              />
              <img
                className="w-full h-full hidden md:block"
                src={`/assets/images/invite/invite-intro-03_${languageCode}.png`}
              />
            </div>
          </div>

          <div className="checkpoint-4 w-full px-[20px] md:px-0 flex flex-col">
            <span
              className={classNames({
                "mb-[15px] md:mb-[25px] text-[#000] font-bold leading-tight tracking-[-0.075em]": true,
                "text-[28px] md:text-[38px] lg:text-[48px]": languageCode === LOCALES.KO,
                "text-[30px] md:text-[36px] lg:text-[48px]": languageCode === LOCALES.JA,
              })}
            >
              {languageTexts._intro_text_13()}
            </span>
            <span
              className={classNames({
                "mb-[30px] md:mb-[50px] text-[#666]": true,
                "text-[16px] md:text-[17px] lg:text-[18px]": languageCode === LOCALES.KO,
                "text-[18px] md:text-[18px] lg:text-[18px]": languageCode === LOCALES.JA,
              })}
            >
              {languageTexts.intro_text_14}
            </span>

            <div className="flex flex-col justify-center items-center w-full mx-auto mb-[100px] md:mb-[150px]">
              <img
                className="w-full h-full md:hidden"
                src={`/assets/images/invite/invite-intro-04-m_${languageCode}.png`}
              />
              <img
                className="w-full h-full hidden md:block"
                src={`/assets/images/invite/invite-intro-04_${languageCode}.png`}
              />
            </div>
          </div>
        </div>
      </div>

      <motion.div
        className="fixed bottom-0 left-0 right-0 md:mb-[40px]"
        variants={footerAnimVariants}
        initial={"hidden"}
        animate={showFloatingButtons ? "show" : "hidden"}
        transition={{ type: "just" }}
      >
        <div className="flex flex-row cursor-pointer mt-[-1px] justify-center items-center border-t border-[#E8E8E8] md:border-0 md:gap-[12px]">
          <div
            className="bg-[#000000] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px] break-keep max-h-[60px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              openPDF()
            }}
          >
            <span className="text-[12px] md:text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_text_21}
            </span>
          </div>

          <div
            className="bg-[#FF0099] flex flex-col justify-center items-center md:rounded-full"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              showLoadingModal()
            }}
          >
            <span className="text-[12px] md:text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_text_22}
            </span>
          </div>
        </div>
      </motion.div>

      <ProgressModal
        isProgressModalVisible={isProgressModalVisible}
        onComplete={() => {
          storeContact()
          setIsProgressModalVisible(false)
          setIsCompleteModalVisible(true)
        }}
      />

      <CompleteModal
        isCompleteModalVisible={isCompleteModalVisible}
        onComplete={() => {
          setIsCompleteModalVisible(false)
          setIsManagerModalVisible(true)
        }}
      />

      <ManagerModal
        name={props.brand.name}
        avatar={
          APP_LOCALE === LOCALES.KO
            ? "/assets/images/manager/manager-mikyeong.png"
            : "/assets/images/manager/manager-momo.png"
        }
        isManagerModalVisible={isManagerModalVisible}
        onOk={() => {
          setIsManagerModalVisible(false)
        }}
      />
    </div>
  )
}

const ProgressModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (props.isProgressModalVisible == false) {
      setProgress(0)
    }

    if (props.isProgressModalVisible) {
      const targetProgress = 100
      const duration = 2000

      const startTime = Date.now()

      const increaseProgress = () => {
        const currentTime = Date.now()
        const elapsedTime = currentTime - startTime

        if (progress < targetProgress && elapsedTime < duration) {
          setProgress(Math.min(targetProgress, (elapsedTime / duration) * targetProgress))
          requestAnimationFrame(increaseProgress)
        } else {
          setProgress(100)
          props.onComplete ? props.onComplete() : null
        }
      }

      increaseProgress()
    }
  }, [props.isProgressModalVisible])

  return (
    <Modal centered={true} open={props.isProgressModalVisible} onOk={props.handleOk} footer={null} closable={false}>
      <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_23}</div>

      <div className="text-center text-black text-lg font-bold">{progress.toFixed(1)}%</div>

      <div className="w-[275px] h-[6px] bg-gray-200 rounded-[32px] relative my-[10px] mx-auto">
        <div
          className="absolute inset-0 h-full bg-orange-500 rounded-[32px]"
          style={{
            width: `${progress.toFixed(1)}%`,
          }}
        />
      </div>
    </Modal>
  )
}

const CompleteModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  useEffect(() => {
    if (props.isCompleteModalVisible) {
      setTimeout(() => {
        props.onComplete ? props.onComplete() : null
      }, 1000)
    }
  }, [props.isCompleteModalVisible])

  return (
    <Modal centered={true} open={props.isCompleteModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[16px]">
        <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_24}</div>

        <div className="mx-auto flex justify-center items-center">
          <img src={`/assets/icons/check-orange.svg`} />
        </div>
      </div>
    </Modal>
  )
}

const ManagerModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  return (
    <Modal centered={true} open={props.isManagerModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[30px] py-[50px]">
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img src={`${props.avatar}`}></img>
          <div className="text-black text-[17px] font-bold">{languageTexts.intro_text_25}</div>
          {/* <img className="max-w-[58px]" src={`/assets/logo/logo-black-sm.svg`}></img> */}
        </div>
        <div className="text-center text-black text-[17px] font-normal py-[15px]">
          {languageTexts._intro_text_26(props.name)}
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(InviteIntroCommon)
